import { useValidation } from '@booking-portal/composables/use-validation';
import { defineRule } from 'vee-validate';

/**
 * Defines the validation rules globally.
 * All validators return translated error messages directly using vue-i18n,
 * which ensures consistent localization across all form fields.
 */
export function useVeeValidate() {
  const validation = useValidation();

  // Define all rules globally with validators that return translated messages
  defineRule('required', validation.required);
  defineRule('email', validation.email);
  defineRule('minArrayLength', validation.minArrayLength);
  defineRule('maxArrayLength', validation.maxArrayLength);
  defineRule<string[]>('emailArray', validation.emailArray);
  defineRule('phoneNumber', validation.phoneNumber);
  defineRule('phoneMaxLength', validation.phoneMaxLength);
  defineRule('maxLength', validation.maxLength);
  defineRule('minDate', validation.minDate);
  defineRule('maxDate', validation.maxDate);
}
